import { COLORS } from '@/constants';
import { MenuItem, Select } from '@mui/material';
import styled from 'styled-components';

export const HouseListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 26px;
  overflow: hidden;

  @media (max-width: 1280px) {
    max-width: 100%;
    gap: 16px;
  }
`;

export const HouseListLine = styled.div`
  display: flex;
  border-bottom: 1px solid black;
  padding: 10px 0;
`;

export const SelectStyled = styled(Select)({
  '& .MuiSelect-select': {
    minWidth: '120px',
    paddingTop: '4px',
    paddingBottom: '4px',
  },
  '&.MuiOutlinedInput-root': {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: COLORS.black,
      borderWidth: '1px',
    },
  },
});

export const MenuItemStyled = styled(MenuItem)({
  '&.MuiMenuItem-root': {
    padding: '4px 10px',
    backgroundColor: COLORS.white,
    '&:hover': {
      backgroundColor: COLORS.black + '!important',
      color: COLORS.white,
    },
    '&.Mui-selected': {
      backgroundColor: COLORS.black + '!important',
      color: COLORS.white,
      '&:hover': {
        backgroundColor: COLORS.black,
        color: COLORS.white,
      },
    },
  },
});

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;
  min-width: 0;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const MapContainer = styled.div`
  display: flex;
  gap: 24px;
  height: 100%;

  @media (max-width: 1280px) {
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
  }
`;

export const MapBox = styled.div`
  height: 100%;
  width: 100%;

  @media (max-width: 1280px) {
    height: 100%;
    order: 1;
  }
`;

export const CardsBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 653px;
  min-width: 313px;
  width: 313px;
  overflow-y: auto;
  flex-shrink: 1;
  min-height: 0;

  @media (max-width: 1280px) {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    overflow-y: unset;
    height: auto;
    order: 2;
  }
`;

export const StatusBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
